import { IconComponentProps } from '../IconTypes';

const OverdueClock = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10C17.5 11.9891 16.7098 13.8968 15.3033 15.3033C13.8968 16.7098 11.9891 17.5 10 17.5C8.01088 17.5 6.10322 16.7098 4.6967 15.3033C3.29018 13.8968 2.5 11.9891 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5ZM9.29688 6.01562V10C9.29688 10.2344 9.41406 10.4541 9.61035 10.5859L12.4229 12.4609C12.7451 12.6777 13.1816 12.5898 13.3984 12.2646C13.6152 11.9395 13.5273 11.5059 13.2021 11.2891L10.7031 9.625V6.01562C10.7031 5.62598 10.3896 5.3125 10 5.3125C9.61035 5.3125 9.29688 5.62598 9.29688 6.01562Z"
      fill="currentColor"
    />
  </svg>
);

export default OverdueClock;
